export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"silentTranslationWarn":true,"silentFallbackWarn":true},
  vueI18nLoader: false,
  locales: [{"acceptedLanguage":"en-us","code":"us","file":"en-US.js","name":"USA","weightUnit":"lbs"},{"acceptedLanguage":"es-us","code":"es-us","file":"es-US.js","name":"USA-ES","weightUnit":"lbs"},{"acceptedLanguage":"en-uk","code":"uk","file":"en-UK.js","name":"UK","weightUnit":"lbs"},{"acceptedLanguage":"en-eu","code":"eu","file":"en-EU.js","name":"EU","weightUnit":"kg"},{"acceptedLanguage":"es-eu","code":"es-eu","file":"es-EU.js","name":"EU-ES","weightUnit":"kg"},{"acceptedLanguage":"en-join","code":"join","file":"en-JOIN.js","name":"JOIN"},{"acceptedLanguage":"es-join","code":"es-join","file":"es-JOIN.js","name":"JOIN-ES"},{"acceptedLanguage":"en-latam","code":"latam","file":"en-LATAM.js","name":"LATAM"},{"acceptedLanguage":"es-latam","code":"es-latam","file":"es-LATAM.js","name":"LATAM-ES"},{"acceptedLanguage":"es-mx","code":"mx","file":"es-MX.js","name":"MX"},{"acceptedLanguage":"es-mx","code":"es-mx","file":"es-MX.js","name":"MX-ES"},{"acceptedLanguage":"en-ca","code":"ca","file":"en-CA.js","name":"CA"},{"acceptedLanguage":"en-au","code":"au","file":"en-AU.js","name":"AU"},{"acceptedLanguage":"en-nz","code":"nz","file":"en-NZ.js","name":"NZ"},{"acceptedLanguage":"en-sa","code":"sa","file":"en-SA.js","name":"SA"},{"acceptedLanguage":"pt-us","code":"pt-us","file":"pt-US.js","name":"US-PT","weightUnit":"lbs"},{"acceptedLanguage":"pt-br","code":"pt-br","file":"pt-BR.js","name":"BR-PT","weightUnit":"kg"},{"acceptedLanguage":"pt-eu","code":"pt-eu","file":"pt-EU.js","name":"EU-PT","weightUnit":"kg"},{"acceptedLanguage":"de-eu","code":"de-eu","file":"de-EU.js","name":"EU-DE","weightUnit":"kg"},{"acceptedLanguage":"en-br","code":"br","file":"en-BR.js","name":"BR-EN","weightUnit":"kg"},{"acceptedLanguage":"de-us","code":"de-us","file":"de-US.js","name":"US-DE","weightUnit":"lbs"},{"acceptedLanguage":"fr-us","code":"fr-us","file":"fr-US.js","name":"US-FR","weightUnit":"lbs"},{"acceptedLanguage":"fr-eu","code":"fr-eu","file":"fr-EU.js","name":"EU-FR","weightUnit":"kg"},{"acceptedLanguage":"it-eu","code":"it-eu","file":"it-EU.js","name":"EU-IT","weightUnit":"kg"},{"acceptedLanguage":"it-us","code":"it-us","file":"it-US.js","name":"US-IT","weightUnit":"lbs"},{"acceptedLanguage":"nl-eu","code":"nl-eu","file":"nl-EU.js","name":"EU-NL","weightUnit":"kg"},{"acceptedLanguage":"nl-us","code":"nl-us","file":"nl-US.js","name":"US-NL","weightUnit":"lbs"},{"acceptedLanguage":"el-eu","code":"el-eu","file":"el-EU.js","name":"EU-EL","weightUnit":"kg"},{"acceptedLanguage":"pl-eu","code":"pl-eu","file":"pl-EU.js","name":"EU-PL","weightUnit":"kg"},{"acceptedLanguage":"el-us","code":"el-us","file":"el-US.js","name":"US-EL","weightUnit":"lbs"},{"acceptedLanguage":"pl-us","code":"pl-us","file":"pl-US.js","name":"US-PL","weightUnit":"lbs"},{"acceptedLanguage":"sv-eu","code":"sv-eu","file":"sv-EU.js","name":"EU-SV","weightUnit":"kg"},{"acceptedLanguage":"sv-us","code":"sv-us","file":"sv-US.js","name":"US-SV","weightUnit":"lbs"}],
  defaultLocale: "us",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "no_prefix",
  lazy: true,
  langDir: "locales/",
  rootRedirect: null,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: (_, __, ___, context) => {
    const getQueryLang = () => {
      try {
        const queryString = process.client ? window.location.search : context.req._parsedOriginalUrl?.query || '';

        const queryParams = new URLSearchParams(queryString);
        return queryParams.get('lang');
      } catch {
        return null;
      }
    };

    const getQueryRegion = () => {
      try {
        const queryString = process.client ? window.location.search : context.req._parsedOriginalUrl?.query || '';
        const queryParams = new URLSearchParams(queryString);
        return queryParams.get('region');
      } catch {
        return null;
      }
    };

    const getCookieLang = () => {
      try {
        const cookieString = process.client ? document.cookie : context.req.headers.cookie || '';

        const match = cookieString.match(/rhLang=([^;]*)/);
        return match ? match[1] : null;
      } catch {
        return null;
      }
    };

    const hostname = process.client ?
    window.location.hostname :
    context.req.headers['x-original-host'] || context.req.headers.host;

    const normalizedHostname = hostname.toLowerCase();

    const _hasRegion = () => {
      const [mightBeRegion] = normalizedHostname.split('.');
      return (
        !mightBeRegion.includes('reverse') &&
        !mightBeRegion.includes('staging') &&
        !mightBeRegion.includes('local') &&
        !mightBeRegion.includes('tour'));
    };

    const _getCountryCodeFromHostname = () => {
      if (!normalizedHostname.length) return 'US';
      const hostnameHasRegion = _hasRegion();
      if (hostnameHasRegion) {
        const [region] = normalizedHostname.split('.');
        return region.toUpperCase();
      }
      return 'US';
    };

    const _getCountryCode = () => {
      const queryRegion = getQueryRegion();
      if (queryRegion) {
        return queryRegion.toUpperCase();
      }
      return _getCountryCodeFromHostname();
    };

    const countryCode = _getCountryCode();

    const queryLang = getQueryLang();
    const cookieLang = getCookieLang();

    const rawLang = queryLang || cookieLang;

    let finalLang;
    if (!rawLang || rawLang === 'en') {
      finalLang = countryCode.toLowerCase();
    } else {
      finalLang = `${rawLang.toLowerCase()}-${countryCode.toLowerCase()}`;
    }

    return finalLang;
  },
  onLanguageSwitched: () => null,
  normalizedLocales: [{"acceptedLanguage":"en-us","code":"us","file":"en-US.js","name":"USA","weightUnit":"lbs"},{"acceptedLanguage":"es-us","code":"es-us","file":"es-US.js","name":"USA-ES","weightUnit":"lbs"},{"acceptedLanguage":"en-uk","code":"uk","file":"en-UK.js","name":"UK","weightUnit":"lbs"},{"acceptedLanguage":"en-eu","code":"eu","file":"en-EU.js","name":"EU","weightUnit":"kg"},{"acceptedLanguage":"es-eu","code":"es-eu","file":"es-EU.js","name":"EU-ES","weightUnit":"kg"},{"acceptedLanguage":"en-join","code":"join","file":"en-JOIN.js","name":"JOIN"},{"acceptedLanguage":"es-join","code":"es-join","file":"es-JOIN.js","name":"JOIN-ES"},{"acceptedLanguage":"en-latam","code":"latam","file":"en-LATAM.js","name":"LATAM"},{"acceptedLanguage":"es-latam","code":"es-latam","file":"es-LATAM.js","name":"LATAM-ES"},{"acceptedLanguage":"es-mx","code":"mx","file":"es-MX.js","name":"MX"},{"acceptedLanguage":"es-mx","code":"es-mx","file":"es-MX.js","name":"MX-ES"},{"acceptedLanguage":"en-ca","code":"ca","file":"en-CA.js","name":"CA"},{"acceptedLanguage":"en-au","code":"au","file":"en-AU.js","name":"AU"},{"acceptedLanguage":"en-nz","code":"nz","file":"en-NZ.js","name":"NZ"},{"acceptedLanguage":"en-sa","code":"sa","file":"en-SA.js","name":"SA"},{"acceptedLanguage":"pt-us","code":"pt-us","file":"pt-US.js","name":"US-PT","weightUnit":"lbs"},{"acceptedLanguage":"pt-br","code":"pt-br","file":"pt-BR.js","name":"BR-PT","weightUnit":"kg"},{"acceptedLanguage":"pt-eu","code":"pt-eu","file":"pt-EU.js","name":"EU-PT","weightUnit":"kg"},{"acceptedLanguage":"de-eu","code":"de-eu","file":"de-EU.js","name":"EU-DE","weightUnit":"kg"},{"acceptedLanguage":"en-br","code":"br","file":"en-BR.js","name":"BR-EN","weightUnit":"kg"},{"acceptedLanguage":"de-us","code":"de-us","file":"de-US.js","name":"US-DE","weightUnit":"lbs"},{"acceptedLanguage":"fr-us","code":"fr-us","file":"fr-US.js","name":"US-FR","weightUnit":"lbs"},{"acceptedLanguage":"fr-eu","code":"fr-eu","file":"fr-EU.js","name":"EU-FR","weightUnit":"kg"},{"acceptedLanguage":"it-eu","code":"it-eu","file":"it-EU.js","name":"EU-IT","weightUnit":"kg"},{"acceptedLanguage":"it-us","code":"it-us","file":"it-US.js","name":"US-IT","weightUnit":"lbs"},{"acceptedLanguage":"nl-eu","code":"nl-eu","file":"nl-EU.js","name":"EU-NL","weightUnit":"kg"},{"acceptedLanguage":"nl-us","code":"nl-us","file":"nl-US.js","name":"US-NL","weightUnit":"lbs"},{"acceptedLanguage":"el-eu","code":"el-eu","file":"el-EU.js","name":"EU-EL","weightUnit":"kg"},{"acceptedLanguage":"pl-eu","code":"pl-eu","file":"pl-EU.js","name":"EU-PL","weightUnit":"kg"},{"acceptedLanguage":"el-us","code":"el-us","file":"el-US.js","name":"US-EL","weightUnit":"lbs"},{"acceptedLanguage":"pl-us","code":"pl-us","file":"pl-US.js","name":"US-PL","weightUnit":"lbs"},{"acceptedLanguage":"sv-eu","code":"sv-eu","file":"sv-EU.js","name":"EU-SV","weightUnit":"kg"},{"acceptedLanguage":"sv-us","code":"sv-us","file":"sv-US.js","name":"US-SV","weightUnit":"lbs"}],
  localeCodes: ["us","es-us","uk","eu","es-eu","join","es-join","latam","es-latam","mx","es-mx","ca","au","nz","sa","pt-us","pt-br","pt-eu","de-eu","br","de-us","fr-us","fr-eu","it-eu","it-us","nl-eu","nl-us","el-eu","pl-eu","el-us","pl-us","sv-eu","sv-us"],
  additionalMessages: [],
}
export const localeFiles = {
  0: "{",
  1: "\"",
  2: "e",
  3: "n",
  4: "-",
  5: "U",
  6: "S",
  7: ".",
  8: "j",
  9: "s",
  10: "\"",
  11: ":",
  12: "\"",
  13: ".",
  14: ".",
  15: "/",
  16: "l",
  17: "o",
  18: "c",
  19: "a",
  20: "l",
  21: "e",
  22: "s",
  23: "/",
  24: "e",
  25: "n",
  26: "-",
  27: "U",
  28: "S",
  29: ".",
  30: "j",
  31: "s",
  32: "\"",
  33: ",",
  34: "\"",
  35: "e",
  36: "s",
  37: "-",
  38: "U",
  39: "S",
  40: ".",
  41: "j",
  42: "s",
  43: "\"",
  44: ":",
  45: "\"",
  46: ".",
  47: ".",
  48: "/",
  49: "l",
  50: "o",
  51: "c",
  52: "a",
  53: "l",
  54: "e",
  55: "s",
  56: "/",
  57: "e",
  58: "s",
  59: "-",
  60: "U",
  61: "S",
  62: ".",
  63: "j",
  64: "s",
  65: "\"",
  66: ",",
  67: "\"",
  68: "e",
  69: "n",
  70: "-",
  71: "U",
  72: "K",
  73: ".",
  74: "j",
  75: "s",
  76: "\"",
  77: ":",
  78: "\"",
  79: ".",
  80: ".",
  81: "/",
  82: "l",
  83: "o",
  84: "c",
  85: "a",
  86: "l",
  87: "e",
  88: "s",
  89: "/",
  90: "e",
  91: "n",
  92: "-",
  93: "U",
  94: "K",
  95: ".",
  96: "j",
  97: "s",
  98: "\"",
  99: ",",
  100: "\"",
  101: "e",
  102: "n",
  103: "-",
  104: "E",
  105: "U",
  106: ".",
  107: "j",
  108: "s",
  109: "\"",
  110: ":",
  111: "\"",
  112: ".",
  113: ".",
  114: "/",
  115: "l",
  116: "o",
  117: "c",
  118: "a",
  119: "l",
  120: "e",
  121: "s",
  122: "/",
  123: "e",
  124: "n",
  125: "-",
  126: "E",
  127: "U",
  128: ".",
  129: "j",
  130: "s",
  131: "\"",
  132: ",",
  133: "\"",
  134: "e",
  135: "s",
  136: "-",
  137: "E",
  138: "U",
  139: ".",
  140: "j",
  141: "s",
  142: "\"",
  143: ":",
  144: "\"",
  145: ".",
  146: ".",
  147: "/",
  148: "l",
  149: "o",
  150: "c",
  151: "a",
  152: "l",
  153: "e",
  154: "s",
  155: "/",
  156: "e",
  157: "s",
  158: "-",
  159: "E",
  160: "U",
  161: ".",
  162: "j",
  163: "s",
  164: "\"",
  165: ",",
  166: "\"",
  167: "e",
  168: "n",
  169: "-",
  170: "J",
  171: "O",
  172: "I",
  173: "N",
  174: ".",
  175: "j",
  176: "s",
  177: "\"",
  178: ":",
  179: "\"",
  180: ".",
  181: ".",
  182: "/",
  183: "l",
  184: "o",
  185: "c",
  186: "a",
  187: "l",
  188: "e",
  189: "s",
  190: "/",
  191: "e",
  192: "n",
  193: "-",
  194: "J",
  195: "O",
  196: "I",
  197: "N",
  198: ".",
  199: "j",
  200: "s",
  201: "\"",
  202: ",",
  203: "\"",
  204: "e",
  205: "s",
  206: "-",
  207: "J",
  208: "O",
  209: "I",
  210: "N",
  211: ".",
  212: "j",
  213: "s",
  214: "\"",
  215: ":",
  216: "\"",
  217: ".",
  218: ".",
  219: "/",
  220: "l",
  221: "o",
  222: "c",
  223: "a",
  224: "l",
  225: "e",
  226: "s",
  227: "/",
  228: "e",
  229: "s",
  230: "-",
  231: "J",
  232: "O",
  233: "I",
  234: "N",
  235: ".",
  236: "j",
  237: "s",
  238: "\"",
  239: ",",
  240: "\"",
  241: "e",
  242: "n",
  243: "-",
  244: "L",
  245: "A",
  246: "T",
  247: "A",
  248: "M",
  249: ".",
  250: "j",
  251: "s",
  252: "\"",
  253: ":",
  254: "\"",
  255: ".",
  256: ".",
  257: "/",
  258: "l",
  259: "o",
  260: "c",
  261: "a",
  262: "l",
  263: "e",
  264: "s",
  265: "/",
  266: "e",
  267: "n",
  268: "-",
  269: "L",
  270: "A",
  271: "T",
  272: "A",
  273: "M",
  274: ".",
  275: "j",
  276: "s",
  277: "\"",
  278: ",",
  279: "\"",
  280: "e",
  281: "s",
  282: "-",
  283: "L",
  284: "A",
  285: "T",
  286: "A",
  287: "M",
  288: ".",
  289: "j",
  290: "s",
  291: "\"",
  292: ":",
  293: "\"",
  294: ".",
  295: ".",
  296: "/",
  297: "l",
  298: "o",
  299: "c",
  300: "a",
  301: "l",
  302: "e",
  303: "s",
  304: "/",
  305: "e",
  306: "s",
  307: "-",
  308: "L",
  309: "A",
  310: "T",
  311: "A",
  312: "M",
  313: ".",
  314: "j",
  315: "s",
  316: "\"",
  317: ",",
  318: "\"",
  319: "e",
  320: "s",
  321: "-",
  322: "M",
  323: "X",
  324: ".",
  325: "j",
  326: "s",
  327: "\"",
  328: ":",
  329: "\"",
  330: ".",
  331: ".",
  332: "/",
  333: "l",
  334: "o",
  335: "c",
  336: "a",
  337: "l",
  338: "e",
  339: "s",
  340: "/",
  341: "e",
  342: "s",
  343: "-",
  344: "M",
  345: "X",
  346: ".",
  347: "j",
  348: "s",
  349: "\"",
  350: ",",
  351: "\"",
  352: "e",
  353: "n",
  354: "-",
  355: "C",
  356: "A",
  357: ".",
  358: "j",
  359: "s",
  360: "\"",
  361: ":",
  362: "\"",
  363: ".",
  364: ".",
  365: "/",
  366: "l",
  367: "o",
  368: "c",
  369: "a",
  370: "l",
  371: "e",
  372: "s",
  373: "/",
  374: "e",
  375: "n",
  376: "-",
  377: "C",
  378: "A",
  379: ".",
  380: "j",
  381: "s",
  382: "\"",
  383: ",",
  384: "\"",
  385: "e",
  386: "n",
  387: "-",
  388: "A",
  389: "U",
  390: ".",
  391: "j",
  392: "s",
  393: "\"",
  394: ":",
  395: "\"",
  396: ".",
  397: ".",
  398: "/",
  399: "l",
  400: "o",
  401: "c",
  402: "a",
  403: "l",
  404: "e",
  405: "s",
  406: "/",
  407: "e",
  408: "n",
  409: "-",
  410: "A",
  411: "U",
  412: ".",
  413: "j",
  414: "s",
  415: "\"",
  416: ",",
  417: "\"",
  418: "e",
  419: "n",
  420: "-",
  421: "N",
  422: "Z",
  423: ".",
  424: "j",
  425: "s",
  426: "\"",
  427: ":",
  428: "\"",
  429: ".",
  430: ".",
  431: "/",
  432: "l",
  433: "o",
  434: "c",
  435: "a",
  436: "l",
  437: "e",
  438: "s",
  439: "/",
  440: "e",
  441: "n",
  442: "-",
  443: "N",
  444: "Z",
  445: ".",
  446: "j",
  447: "s",
  448: "\"",
  449: ",",
  450: "\"",
  451: "e",
  452: "n",
  453: "-",
  454: "S",
  455: "A",
  456: ".",
  457: "j",
  458: "s",
  459: "\"",
  460: ":",
  461: "\"",
  462: ".",
  463: ".",
  464: "/",
  465: "l",
  466: "o",
  467: "c",
  468: "a",
  469: "l",
  470: "e",
  471: "s",
  472: "/",
  473: "e",
  474: "n",
  475: "-",
  476: "S",
  477: "A",
  478: ".",
  479: "j",
  480: "s",
  481: "\"",
  482: ",",
  483: "\"",
  484: "p",
  485: "t",
  486: "-",
  487: "U",
  488: "S",
  489: ".",
  490: "j",
  491: "s",
  492: "\"",
  493: ":",
  494: "\"",
  495: ".",
  496: ".",
  497: "/",
  498: "l",
  499: "o",
  500: "c",
  501: "a",
  502: "l",
  503: "e",
  504: "s",
  505: "/",
  506: "p",
  507: "t",
  508: "-",
  509: "U",
  510: "S",
  511: ".",
  512: "j",
  513: "s",
  514: "\"",
  515: ",",
  516: "\"",
  517: "p",
  518: "t",
  519: "-",
  520: "B",
  521: "R",
  522: ".",
  523: "j",
  524: "s",
  525: "\"",
  526: ":",
  527: "\"",
  528: ".",
  529: ".",
  530: "/",
  531: "l",
  532: "o",
  533: "c",
  534: "a",
  535: "l",
  536: "e",
  537: "s",
  538: "/",
  539: "p",
  540: "t",
  541: "-",
  542: "B",
  543: "R",
  544: ".",
  545: "j",
  546: "s",
  547: "\"",
  548: ",",
  549: "\"",
  550: "p",
  551: "t",
  552: "-",
  553: "E",
  554: "U",
  555: ".",
  556: "j",
  557: "s",
  558: "\"",
  559: ":",
  560: "\"",
  561: ".",
  562: ".",
  563: "/",
  564: "l",
  565: "o",
  566: "c",
  567: "a",
  568: "l",
  569: "e",
  570: "s",
  571: "/",
  572: "p",
  573: "t",
  574: "-",
  575: "E",
  576: "U",
  577: ".",
  578: "j",
  579: "s",
  580: "\"",
  581: ",",
  582: "\"",
  583: "d",
  584: "e",
  585: "-",
  586: "E",
  587: "U",
  588: ".",
  589: "j",
  590: "s",
  591: "\"",
  592: ":",
  593: "\"",
  594: ".",
  595: ".",
  596: "/",
  597: "l",
  598: "o",
  599: "c",
  600: "a",
  601: "l",
  602: "e",
  603: "s",
  604: "/",
  605: "d",
  606: "e",
  607: "-",
  608: "E",
  609: "U",
  610: ".",
  611: "j",
  612: "s",
  613: "\"",
  614: ",",
  615: "\"",
  616: "e",
  617: "n",
  618: "-",
  619: "B",
  620: "R",
  621: ".",
  622: "j",
  623: "s",
  624: "\"",
  625: ":",
  626: "\"",
  627: ".",
  628: ".",
  629: "/",
  630: "l",
  631: "o",
  632: "c",
  633: "a",
  634: "l",
  635: "e",
  636: "s",
  637: "/",
  638: "e",
  639: "n",
  640: "-",
  641: "B",
  642: "R",
  643: ".",
  644: "j",
  645: "s",
  646: "\"",
  647: ",",
  648: "\"",
  649: "d",
  650: "e",
  651: "-",
  652: "U",
  653: "S",
  654: ".",
  655: "j",
  656: "s",
  657: "\"",
  658: ":",
  659: "\"",
  660: ".",
  661: ".",
  662: "/",
  663: "l",
  664: "o",
  665: "c",
  666: "a",
  667: "l",
  668: "e",
  669: "s",
  670: "/",
  671: "d",
  672: "e",
  673: "-",
  674: "U",
  675: "S",
  676: ".",
  677: "j",
  678: "s",
  679: "\"",
  680: ",",
  681: "\"",
  682: "f",
  683: "r",
  684: "-",
  685: "U",
  686: "S",
  687: ".",
  688: "j",
  689: "s",
  690: "\"",
  691: ":",
  692: "\"",
  693: ".",
  694: ".",
  695: "/",
  696: "l",
  697: "o",
  698: "c",
  699: "a",
  700: "l",
  701: "e",
  702: "s",
  703: "/",
  704: "f",
  705: "r",
  706: "-",
  707: "U",
  708: "S",
  709: ".",
  710: "j",
  711: "s",
  712: "\"",
  713: ",",
  714: "\"",
  715: "f",
  716: "r",
  717: "-",
  718: "E",
  719: "U",
  720: ".",
  721: "j",
  722: "s",
  723: "\"",
  724: ":",
  725: "\"",
  726: ".",
  727: ".",
  728: "/",
  729: "l",
  730: "o",
  731: "c",
  732: "a",
  733: "l",
  734: "e",
  735: "s",
  736: "/",
  737: "f",
  738: "r",
  739: "-",
  740: "E",
  741: "U",
  742: ".",
  743: "j",
  744: "s",
  745: "\"",
  746: ",",
  747: "\"",
  748: "i",
  749: "t",
  750: "-",
  751: "E",
  752: "U",
  753: ".",
  754: "j",
  755: "s",
  756: "\"",
  757: ":",
  758: "\"",
  759: ".",
  760: ".",
  761: "/",
  762: "l",
  763: "o",
  764: "c",
  765: "a",
  766: "l",
  767: "e",
  768: "s",
  769: "/",
  770: "i",
  771: "t",
  772: "-",
  773: "E",
  774: "U",
  775: ".",
  776: "j",
  777: "s",
  778: "\"",
  779: ",",
  780: "\"",
  781: "i",
  782: "t",
  783: "-",
  784: "U",
  785: "S",
  786: ".",
  787: "j",
  788: "s",
  789: "\"",
  790: ":",
  791: "\"",
  792: ".",
  793: ".",
  794: "/",
  795: "l",
  796: "o",
  797: "c",
  798: "a",
  799: "l",
  800: "e",
  801: "s",
  802: "/",
  803: "i",
  804: "t",
  805: "-",
  806: "U",
  807: "S",
  808: ".",
  809: "j",
  810: "s",
  811: "\"",
  812: ",",
  813: "\"",
  814: "n",
  815: "l",
  816: "-",
  817: "E",
  818: "U",
  819: ".",
  820: "j",
  821: "s",
  822: "\"",
  823: ":",
  824: "\"",
  825: ".",
  826: ".",
  827: "/",
  828: "l",
  829: "o",
  830: "c",
  831: "a",
  832: "l",
  833: "e",
  834: "s",
  835: "/",
  836: "n",
  837: "l",
  838: "-",
  839: "E",
  840: "U",
  841: ".",
  842: "j",
  843: "s",
  844: "\"",
  845: ",",
  846: "\"",
  847: "n",
  848: "l",
  849: "-",
  850: "U",
  851: "S",
  852: ".",
  853: "j",
  854: "s",
  855: "\"",
  856: ":",
  857: "\"",
  858: ".",
  859: ".",
  860: "/",
  861: "l",
  862: "o",
  863: "c",
  864: "a",
  865: "l",
  866: "e",
  867: "s",
  868: "/",
  869: "n",
  870: "l",
  871: "-",
  872: "U",
  873: "S",
  874: ".",
  875: "j",
  876: "s",
  877: "\"",
  878: ",",
  879: "\"",
  880: "e",
  881: "l",
  882: "-",
  883: "E",
  884: "U",
  885: ".",
  886: "j",
  887: "s",
  888: "\"",
  889: ":",
  890: "\"",
  891: ".",
  892: ".",
  893: "/",
  894: "l",
  895: "o",
  896: "c",
  897: "a",
  898: "l",
  899: "e",
  900: "s",
  901: "/",
  902: "e",
  903: "l",
  904: "-",
  905: "E",
  906: "U",
  907: ".",
  908: "j",
  909: "s",
  910: "\"",
  911: ",",
  912: "\"",
  913: "p",
  914: "l",
  915: "-",
  916: "E",
  917: "U",
  918: ".",
  919: "j",
  920: "s",
  921: "\"",
  922: ":",
  923: "\"",
  924: ".",
  925: ".",
  926: "/",
  927: "l",
  928: "o",
  929: "c",
  930: "a",
  931: "l",
  932: "e",
  933: "s",
  934: "/",
  935: "p",
  936: "l",
  937: "-",
  938: "E",
  939: "U",
  940: ".",
  941: "j",
  942: "s",
  943: "\"",
  944: ",",
  945: "\"",
  946: "e",
  947: "l",
  948: "-",
  949: "U",
  950: "S",
  951: ".",
  952: "j",
  953: "s",
  954: "\"",
  955: ":",
  956: "\"",
  957: ".",
  958: ".",
  959: "/",
  960: "l",
  961: "o",
  962: "c",
  963: "a",
  964: "l",
  965: "e",
  966: "s",
  967: "/",
  968: "e",
  969: "l",
  970: "-",
  971: "U",
  972: "S",
  973: ".",
  974: "j",
  975: "s",
  976: "\"",
  977: ",",
  978: "\"",
  979: "p",
  980: "l",
  981: "-",
  982: "U",
  983: "S",
  984: ".",
  985: "j",
  986: "s",
  987: "\"",
  988: ":",
  989: "\"",
  990: ".",
  991: ".",
  992: "/",
  993: "l",
  994: "o",
  995: "c",
  996: "a",
  997: "l",
  998: "e",
  999: "s",
  1000: "/",
  1001: "p",
  1002: "l",
  1003: "-",
  1004: "U",
  1005: "S",
  1006: ".",
  1007: "j",
  1008: "s",
  1009: "\"",
  1010: ",",
  1011: "\"",
  1012: "s",
  1013: "v",
  1014: "-",
  1015: "E",
  1016: "U",
  1017: ".",
  1018: "j",
  1019: "s",
  1020: "\"",
  1021: ":",
  1022: "\"",
  1023: ".",
  1024: ".",
  1025: "/",
  1026: "l",
  1027: "o",
  1028: "c",
  1029: "a",
  1030: "l",
  1031: "e",
  1032: "s",
  1033: "/",
  1034: "s",
  1035: "v",
  1036: "-",
  1037: "E",
  1038: "U",
  1039: ".",
  1040: "j",
  1041: "s",
  1042: "\"",
  1043: ",",
  1044: "\"",
  1045: "s",
  1046: "v",
  1047: "-",
  1048: "U",
  1049: "S",
  1050: ".",
  1051: "j",
  1052: "s",
  1053: "\"",
  1054: ":",
  1055: "\"",
  1056: ".",
  1057: ".",
  1058: "/",
  1059: "l",
  1060: "o",
  1061: "c",
  1062: "a",
  1063: "l",
  1064: "e",
  1065: "s",
  1066: "/",
  1067: "s",
  1068: "v",
  1069: "-",
  1070: "U",
  1071: "S",
  1072: ".",
  1073: "j",
  1074: "s",
  1075: "\"",
  1076: "}",
}

export const localeMessages = {
  'en-US.js': () => import('../../locales/en-US.js' /* webpackChunkName: "lang-en-US.js" */),
  'es-US.js': () => import('../../locales/es-US.js' /* webpackChunkName: "lang-es-US.js" */),
  'en-UK.js': () => import('../../locales/en-UK.js' /* webpackChunkName: "lang-en-UK.js" */),
  'en-EU.js': () => import('../../locales/en-EU.js' /* webpackChunkName: "lang-en-EU.js" */),
  'es-EU.js': () => import('../../locales/es-EU.js' /* webpackChunkName: "lang-es-EU.js" */),
  'en-JOIN.js': () => import('../../locales/en-JOIN.js' /* webpackChunkName: "lang-en-JOIN.js" */),
  'es-JOIN.js': () => import('../../locales/es-JOIN.js' /* webpackChunkName: "lang-es-JOIN.js" */),
  'en-LATAM.js': () => import('../../locales/en-LATAM.js' /* webpackChunkName: "lang-en-LATAM.js" */),
  'es-LATAM.js': () => import('../../locales/es-LATAM.js' /* webpackChunkName: "lang-es-LATAM.js" */),
  'es-MX.js': () => import('../../locales/es-MX.js' /* webpackChunkName: "lang-es-MX.js" */),
  'en-CA.js': () => import('../../locales/en-CA.js' /* webpackChunkName: "lang-en-CA.js" */),
  'en-AU.js': () => import('../../locales/en-AU.js' /* webpackChunkName: "lang-en-AU.js" */),
  'en-NZ.js': () => import('../../locales/en-NZ.js' /* webpackChunkName: "lang-en-NZ.js" */),
  'en-SA.js': () => import('../../locales/en-SA.js' /* webpackChunkName: "lang-en-SA.js" */),
  'pt-US.js': () => import('../../locales/pt-US.js' /* webpackChunkName: "lang-pt-US.js" */),
  'pt-BR.js': () => import('../../locales/pt-BR.js' /* webpackChunkName: "lang-pt-BR.js" */),
  'pt-EU.js': () => import('../../locales/pt-EU.js' /* webpackChunkName: "lang-pt-EU.js" */),
  'de-EU.js': () => import('../../locales/de-EU.js' /* webpackChunkName: "lang-de-EU.js" */),
  'en-BR.js': () => import('../../locales/en-BR.js' /* webpackChunkName: "lang-en-BR.js" */),
  'de-US.js': () => import('../../locales/de-US.js' /* webpackChunkName: "lang-de-US.js" */),
  'fr-US.js': () => import('../../locales/fr-US.js' /* webpackChunkName: "lang-fr-US.js" */),
  'fr-EU.js': () => import('../../locales/fr-EU.js' /* webpackChunkName: "lang-fr-EU.js" */),
  'it-EU.js': () => import('../../locales/it-EU.js' /* webpackChunkName: "lang-it-EU.js" */),
  'it-US.js': () => import('../../locales/it-US.js' /* webpackChunkName: "lang-it-US.js" */),
  'nl-EU.js': () => import('../../locales/nl-EU.js' /* webpackChunkName: "lang-nl-EU.js" */),
  'nl-US.js': () => import('../../locales/nl-US.js' /* webpackChunkName: "lang-nl-US.js" */),
  'el-EU.js': () => import('../../locales/el-EU.js' /* webpackChunkName: "lang-el-EU.js" */),
  'pl-EU.js': () => import('../../locales/pl-EU.js' /* webpackChunkName: "lang-pl-EU.js" */),
  'el-US.js': () => import('../../locales/el-US.js' /* webpackChunkName: "lang-el-US.js" */),
  'pl-US.js': () => import('../../locales/pl-US.js' /* webpackChunkName: "lang-pl-US.js" */),
  'sv-EU.js': () => import('../../locales/sv-EU.js' /* webpackChunkName: "lang-sv-EU.js" */),
  'sv-US.js': () => import('../../locales/sv-US.js' /* webpackChunkName: "lang-sv-US.js" */),
}
